import { forwardRef, type AnchorHTMLAttributes } from 'react';

import { cn } from '@ui/lib/utils';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  external?: boolean;
  unstyled?: boolean;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ external = false, unstyled = false, className, children, ...props }, ref) => (
    <a
      ref={ref}
      data-slot="link"
      // eslint-disable-next-line jsx-a11y/no-redundant-roles -- base-ui sets role="button" when a Button renders it
      role="link"
      className={cn(!unstyled && 'text-primary underline-offset-4 hover:underline', className)}
      {...(external && { target: '_blank', rel: 'noreferrer' })}
      {...props}
    >
      {children}
    </a>
  )
);

Link.displayName = 'Link';

export { Link };
export type { LinkProps };
